import { Component, h, ComponentInterface, State, Prop, Element } from '@stencil/core';
import { guid } from 'utils';


@Component({
	tag: 'kdx-arrow-link',
	styleUrl: 'kdx-arrow-link.scss',
	shadow: false
})
export class StArrowLink implements ComponentInterface {

	@Element() root: HTMLElement;
	
	@Prop() label: string;
	@Prop() href: string = "";
	@Prop() layout: string;
	@Prop() classes: string;
	@Prop() target: string;
	@Prop() isSpeedbump: boolean = false;
	
	@State() guid: string = guid();

	render() {
		return (
			<a 
				href={this.href} 
				class={`arrow-link${this.layout ? this.layout : ''}${this.classes ? ' ' + this.classes : ''}${this.isSpeedbump ? ' speedbump-link' : ''}`} 
				aria-label={this.label} 
				id={`arrow-link-${this.guid}`}
				target={this.target ? this.target : '_self'}
			>
				<slot />
				<span class="svg-icon">
							<kdx-icon icon="chevron-right" />
				</span>
			</a>
		);
	}
}